// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangeSpaceVisibilityPopup__container-fbfefe {
  flex: 1;
  margin-bottom: 10px;
  padding-top: 10px;
  overflow-x: hidden;
  overflow-y: auto;
}

.ChangeSpaceVisibilityPopup__separator-c5bef8 {
  width: 100%;
  height: 12px;
  margin: 10px 0px;
  background-color: var(--base-15);
  border: none;
}

.ChangeSpaceVisibilityPopup__group-list-c8d64d {
  display: flex;
  flex-direction: column;
}

.ChangeSpaceVisibilityPopup__switch-bb04d2 {
  height: 46px;
  padding: 0px 24px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ChangeSpaceVisibilityPopup/ChangeSpaceVisibilityPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gCAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  margin-bottom: 10px;\n  padding-top: 10px;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.separator {\n  width: 100%;\n  height: 12px;\n  margin: 10px 0px;\n  background-color: var(--base-15);\n  border: none;\n}\n\n.group-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.switch {\n  height: 46px;\n  padding: 0px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChangeSpaceVisibilityPopup__container-fbfefe`,
	"separator": `ChangeSpaceVisibilityPopup__separator-c5bef8`,
	"group-list": `ChangeSpaceVisibilityPopup__group-list-c8d64d`,
	"groupList": `ChangeSpaceVisibilityPopup__group-list-c8d64d`,
	"switch": `ChangeSpaceVisibilityPopup__switch-bb04d2`
};
module.exports = ___CSS_LOADER_EXPORT___;
